import { useV2ListUpcomingReleasesQuery } from "@generated";

export interface UpcomingRelease {
  id: string;
  name: string;
  description: string;
  betaReleaseDate: string;
}

interface ListUpcomingReleasesResult {
  upcomingReleases: UpcomingRelease[];
  isLoading: boolean;
  error: unknown;
}

const useListUpcomingReleases = (): ListUpcomingReleasesResult => {
  const { data, isLoading, error } = useV2ListUpcomingReleasesQuery(
    { sort: ["beta-release-date"] },
    { refetchOnMountOrArgChange: true }
  );

  const upcomingReleases: UpcomingRelease[] = (data?.data || []).map((row) => ({
    id: row.id ?? "",
    name: row.attributes?.name ?? "",
    description: row.attributes?.description ?? "",
    betaReleaseDate: row.attributes?.["beta-release-date"] ?? "",
  }));

  return { upcomingReleases, isLoading, error };
};

export default useListUpcomingReleases;
